const imgTest = require('./img.jpg');
const imgTestLarge = require('./img2.jpg');

export { imgTest, imgTestLarge };
